module.exports = __webpack_public_path__ + "img/good2.48edb29d.jpg";